import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class ChannelBaseComponent extends BaseComponent {
  public text: string = "Channel";

  constructor(userService: UserService) {
    super(userService);
  }
}
